var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileLoggedInWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87104 15.5389C5.03537 16.1607 4.49697 16.9222 4.2712 17.7217C2.31367 15.9671 1.08203 13.4191 1.08203 10.5833C1.08203 5.2906 5.37264 1 10.6654 1C15.9581 1 20.2487 5.2906 20.2487 10.5833C20.2487 13.4201 19.0162 15.9689 17.0575 17.7236C16.832 16.9234 16.2934 16.1611 15.4571 15.5389C12.8339 13.5983 8.51347 13.5983 5.87104 15.5389ZM10.454 12.0835C10.5393 12.0728 10.6354 12.0728 10.7101 12.0835C12.5881 12.0194 14.0714 10.4804 14.082 8.58884C14.082 6.65449 12.5134 5.0835 10.582 5.0835C8.63996 5.0835 7.08203 6.65449 7.08203 8.58884C7.08203 10.4804 8.57593 12.0194 10.454 12.0835Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5833 20.1667C15.8761 20.1667 20.1667 15.8761 20.1667 10.5833C20.1667 5.2906 15.8761 1 10.5833 1C5.2906 1 1 5.2906 1 10.5833C1 15.8761 5.2906 20.1667 10.5833 20.1667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLoggedInWhite);
export default __webpack_public_path__ + "static/media/profileLoggedInWhite.2c67ee6aae0a27c5c5a3ecc91c73cef8.svg";
export { ForwardRef as ReactComponent };